<template>
  <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-start row mx-3 mt-0 align-center>
            <v-flex>
              <v-layout row>
                <v-icon class="mr-2">fa-plus-circle</v-icon>
                <div class="text-xs-left" style="font-size: 20px; font-weight: 600;">Add Dashboards</div>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex>
                  <v-layout class="buttons mb-0 mr-0" justify-end row>
                    <v-btn icon @click="cancel" class="pa-0 mr-0">
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-flex mb-0 xs12 mx-2>
            <v-form v-model="valid" @submit="addDashboards" ref="addDashboardForm">
              <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                <v-layout hide-details justify-start row mt-0 mb-0>
                  <v-flex hide-details mx-4 xs10>
                    <v-autocomplete
                      :items="addDashboardList"
                      v-model="selectedDashboards"
                      :item-text="dashboardTitle"
                      item-value="DBID"
                      label="Dashboards*"
                      required
                      :rules="requiredRules"
                      multiple
                      chips
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @input="remove(data.item)"
                        >{{ data.item.DashboardID }} - {{ data.item.Name }}</v-chip>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex mx-4 xs2>
                    <v-btn color="success" @click="addDashboards" class="ml-2 mr-4">Add Dashboards</v-btn>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-form>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
    <div class="pb-5">
      <zigZag></zigZag>
    </div>
  </v-flex>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import axios from "axios";
import Bus from "../../bus";
import moment from "moment";
import zigZag from "../../components/ZigZag";

export default {
  name: "AddDashboard",

  components: {
    Spinner,
    zigZag
  },

  props: {
    addDashboardList: {
      type: Array,
      default: null
    },
    dashboards: {
      type: Array,
      default: null
    }
  },

  data: () => ({
    dialog: false,
    valid: true,
    selectedDashboards: [],

    ddlAccounts: [],
    isBatchDescriptionDisabled: false,

    formType: null,

    resolve: null,
    reject: null,
    record: {},
    date: false,
    ddlBatchRecordType: [],

    requiredRules: [v => !!v || "Required"],
    amountRules: [
      v => !!v || "Required",
      v =>
        new RegExp("^\\d+(?:\\.\\d{0,2})?$").test(v) ||
        "Must be in currency format"
    ]
  }),
  computed: {
    currentDate() {
      return moment()
        .format("YYYY-MM-DD")
        .toString();
    }
  },

  mounted() {
    // this.initialize();
  },

  methods: {
    // initialize() {

    // },
    async open(item) {
      this.record = await Object.assign({}, item);
      this.formType = "new";
      this.dialog = true;
      // this.getDropDownLists();
    },

    remove(item) {
      const index = this.selectedDashboards.indexOf(item.DBID);
      if (index >= 0) this.selectedDashboards.splice(index, 1);
    },
    async addDashboards() {
      var selectedDashboards = this.selectedDashboards;
      var dashboards = this.dashboards;
      if (this.selectedDashboards.length > 0) {
        for (var i = 0; i < this.selectedDashboards.length; i++) {
          if (i == 0 || this.isEven(i)) {
            await dashboards[0].items.push({
              id: this.selectedDashboards[i].toString()
            });
          } else {
            await dashboards[1].items.push({
              id: this.selectedDashboards[i].toString()
            });
          }
        }
        Bus.$emit("alert", {
          color: "success",
          message: "Added Dashboards Successfully!"
        });

        this.close();
      }
    },
    isEven(n) {
      if (!isNaN(n)) {
        return n % 2 === 0;
      }
    },

    cancel() {
      this.selectedDashboards = [];
      this.dialog = false;
      this.$emit("parentInitSelectedRow");
    },
    close() {
      this.selectedDashboards = [];
      this.dialog = false;
      this.$emit("parentRefresh");
    },
    isOpen() {
      return this.dialog;
    },
    dashboardTitle(item) {
      return item.DashboardID + " - " + item.Name;
    }
  }
};
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

